'use client';

import { useQuery } from '@tanstack/react-query';
import Env from 'src/environmentVariables/EnvironmentVariables';

interface AlertData {
	heading: string;
	description: string;
	imageSrc?: string;
	linkUrl?: string;
	linkText?: string;
	pathToAlertOn?: string;
	untilMs?: number;
}

interface MarketAlertData extends Pick<AlertData, 'untilMs'> {
	baseSymbol: string;
}

export type Alert =
	| {
			alertType: 'feature' | 'warning';
			alertData: AlertData;
	  }
	| {
			alertType: 'market' | 'collateral';
			alertData: MarketAlertData;
	  };

export type AppParamsProps = {
	status: string;
	message: string;
	alert: Alert;
	statusBar: {
		status: 'warn' | 'error';
		message: string;
		showOnlyForInvolvedUsers?: boolean;
		involvedMarketIndexes?: number[];
		involvedMarketTypes?: ('perp' | 'spot')[];
	};
};

const fetchAppParams = async (url: string): Promise<AppParamsProps> => {
	const res = await fetch(url, {
		headers: {
			'Cache-Control': 'no-cache',
		},
	});
	return res.json();
};

const useAppParams = () => {
	const paramsUrl = `${Env.dataApiUrl}/params`;

	const { data, error } = useQuery({
		queryKey: ['appParams', paramsUrl],
		queryFn: () => fetchAppParams(paramsUrl),
		refetchInterval: 60 * 1000,
	});

	if (error) {
		console.error(error);
	}

	return data;
};

export default useAppParams;
